import React from 'react'
import { useTranslation } from 'react-i18next'
import { Stack } from '@mui/system'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const CustomListLink = ({ href, children }: { href: string; children: React.ReactNode }) => {
    return (
        <Link
            href={href}
            target='_blank'
            sx={(theme) => ({
                color: theme.palette.grey[500],
                display: 'flex',
                p: 2,
                textDecoration: 'none',
                alignItems: 'center',
                '&:hover': {
                    backgroundColor: theme.palette.grey[100],
                    textDecoration: 'none',
                },
            })}
        >
            {children}
        </Link>
    )
}

function Footer() {
    const { t } = useTranslation()

    return (
        <Box sx={{ px: 6, backgroundColor: '#fff' }}>
            <Grid container>
                <Grid sx={{ display: { xs: 'none', md: 'block' } }} container size={{ xs: 12, md: 8 }}>
                    <Stack spacing={2} direction={'row'}>
                        <CustomListLink href='https://www.financelab.se/anvandarvillkor'>
                            {t('site.footer.termsOfUse')}
                        </CustomListLink>
                        <CustomListLink href='https://www.financelab.se/integritetspolicy'>
                            {t('site.footer.privacyPolicy')}
                        </CustomListLink>
                        <Typography
                            variant='body1'
                            sx={[
                                {
                                    p: 4,
                                },
                                (theme) => ({
                                    color: theme.palette.grey[500],
                                }),
                            ]}
                        >
                            Datakällor: Millistream, Bolagsverket, MFN
                        </Typography>
                    </Stack>
                </Grid>
                <Grid
                    container
                    size={{ xs: 12, md: 4 }}
                    sx={{
                        justifyContent: 'flex-end',
                    }}
                >
                    <CustomListLink href='https://www.financelab.se'>{`© ${new Date().getFullYear()} - Finance Lab AB`}</CustomListLink>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer
